// extracted by mini-css-extract-plugin
export default {"root":"qAr26lC_5MZ4X1KJwrea","title":"F3tExrPCBYFAwWvTmvxk"};